module.exports = __webpack_public_path__ + "img/5.7eedf060.jpg";